import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faFileImage, faPlay, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';
import { changeNum } from './common/function';

function RandomBox() {
    let dark = useSelector((state) => state.Darkmode.value);
    const darkname = dark ? "dark" : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    const [message, setMessage] = useState({ code: -1, msg: "" });
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);

    // 로그인 상태 체크
    useEffect(() => {
        const objString = localStorage.getItem("token");
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem("token");
                dispatch(checkLogin(false));
                navigate("/");
            } else {
                dispatch(checkLogin(true));
            }
        } else {
            dispatch(checkLogin(false));
            navigate("/");
        }
    }, []);

    // 초기 데이터 세팅
    useEffect(() => {
        SettingData();
    }, []);

    const SettingData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/randombox", {
        })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code > 0) {
                    console.log(tmp)
                    setData(tmp?.data?.randombox ?? [])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onSubmitSettingData = async () => {
        console.log(data)
        await axios.post(process.env.REACT_APP_API + "/api/randombox", {
            boxes: data,
        }).then((response) => {
            let tmp = response.data;
            setIsEditing(false);
        }).catch(error => {
            console.error(error);
        });
    }

    // ② 수정 모드로 진입
    const handleEdit = () => {
        // 원본 데이터 복제 (수정 취소 시 복구 용도)
        setOriginalData(JSON.parse(JSON.stringify(data)));
        setIsEditing(true);
    };

    // ③ 수정 취소 → 원본으로 복원
    const handleCancel = () => {
        setData(originalData);
        setIsEditing(false);
    };

    // ④ 입력값 변경 핸들러 (특정 인덱스의 특정 필드 수정)
    const handleChange = (index, field, value) => {
        if (!/^\d*$/.test(value)) return; // 숫자만 입력 가능하도록 제한

        const updatedData = [...data];
        updatedData[index] = {
            ...updatedData[index],
            [field]: value,
        };
        setData(updatedData);
    };

    return (
        <div className="main">
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                <div className={`member-2 ${darkname}`} style={{ width: "1000px" }}>

                    {/* 테이블 헤더 (원하는 컬럼명에 맞춰 수정) */}
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "5%", minWidth: "50px" }}>ID</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>구매금액</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>최소배율(%)</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>최대배율(%)</div>
                        <div style={{ width: "15%", minWidth: "200px" }}>당첨금액 범위</div>
                        <div>비고</div>
                        {/* 필요한 칼럼이 더 있다면 추가 */}
                    </div>

                    {/* 테이블 바디: data 배열 전체를 행으로 렌더 */}
                    <div className="table-body" style={{ minHeight: "auto" }}>
                        {data.map((row, index) => (
                            <div className={`table-body-tr ${darkname}`} key={index}>
                                {/* 1) ID */}
                                <div className="td" style={{ width: "5%", minWidth: "50px" }}>
                                    {row.id}
                                </div>

                                {/* 2) 구매금액 */}
                                <div className="right td" style={{ width: "10%", minWidth: "100px" }}>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={row.buy_amount}
                                            onChange={(e) =>
                                                handleChange(index, "buy_amount", e.target.value)
                                            }
                                        />
                                    ) : (
                                        changeNum(row.buy_amount)
                                    )}
                                </div>

                                <div className="right td" style={{ width: "10%", minWidth: "100px" }}>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={Number(row.min_rate)}
                                            onChange={(e) =>
                                                handleChange(index, "min_rate", e.target.value)
                                            }
                                        />
                                    ) : (
                                        changeNum(Number(row.min_rate))
                                    )}
                                </div>
                                <div className="right td" style={{ width: "10%", minWidth: "100px" }}>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={Number(row.max_rate)}
                                            onChange={(e) =>
                                                handleChange(index, "max_rate", e.target.value)
                                            }
                                        />
                                    ) : (
                                        changeNum(Number(row.max_rate))
                                    )}
                                </div>
                                <div className="td" style={{ width: "15%", minWidth: "200px" }}>
                                    {changeNum(row.min_rate * row.buy_amount / 100)} ~ {changeNum(row.max_rate * row.buy_amount / 100)}
                                </div>
                                <div className="td" ></div>
                            </div>
                        ))}
                    </div>

                    {/* 수정 / 취소 / 등록 버튼 */}
                    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                        {isEditing ? (
                            <>
                                <div className='gameSetting-btn-2' onClick={handleCancel}>
                                    취소
                                </div>
                                <div className='gameSetting-btn-2' onClick={onSubmitSettingData}>
                                    등록
                                </div>
                            </>
                        ) : (
                            <div className='gameSetting-btn-2' onClick={handleEdit}>
                                수정
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default RandomBox;
